import React from "react"

export const COLUMNS = [
  {
    Header: "Patient ID",
    accessor: "patientMocId",
  },
  {
    Header: "Name",
    accessor: (d: any) => (!d?.isVip ? `${d.name}` : "***Masked***"),
  },
  {
    Header: "Phone Number",
    accessor: "phoneNumber",
    height: "100px",
    Cell: (row: any) => {
      return <span title={row.value}>{row.value}</span>
    },
  },
  {
    Header: "Pending Bills",
    accessor: "pendingBills",
    Cell: (row: any) => {
      return <span title={row.value}>{row.value}</span>
    },
  },
  {
    Header: "Pending Amount",
    accessor: "totalPendingAmount",
    Cell: (row: any) => {
      return <span title={row.value}>{row.value?.toFixed(2)}</span>
    },
  },
  {
    Header: "Status",
    accessor: "patientStatus",
    Cell: (row: any) => {
      return <span style={{ color: 'green' }} title={row.value}>{row.value}</span>
    },
  },
  {
    Header: '',
    accessor: 'Edit',
    Cell: ({ cell: { } }) => (
      <img
        className="eye-icon"
        src={'../../assets/images/eyeIcon.svg'}
        width={32}
        height={30}
        style={{
          marginTop: '6px',
          paddingRight: '15px',
          width: '40px',
          height: '40px',
        }}
        alt="eye"
      />
    ),
  },
]
